module.exports = __webpack_public_path__ + "static/media/AppPromo.a84f5bc7.png";